/* eslint-disable @typescript-eslint/naming-convention */
import type { ComponentStyleConfig, SystemStyleObject } from '@chakra-ui/react';

// More details: https://chakra-ui.com/community/recipes/floating-labels

const activeLabelStyles = {
  transform: 'scale(0.85) translateY(-32px)',
  fontStyle: 'normal',
  opacity: 1,
};

const floatingVariant: SystemStyleObject = {
  container: {
    _focusWithin: {
      label: {
        ...activeLabelStyles,
        color: '#060504',
        my: 4,
      },
    },
    'input:not(:placeholder-shown) + label, .chakra-select__wrapper + label': {
      ...activeLabelStyles,
    },
    label: {
      top: 0,
      left: 0,
      zIndex: 2,
      position: 'absolute',
      backgroundColor: 'white',
      pointerEvents: 'none',
      mx: 3,
      px: 1,
      my: 4,
      transformOrigin: 'left top',
      color: '#060504',
      fontWeight: 'light',
      fontStyle: 'italic',
      fontSize: 'medium',
      opacity: 0,
      whiteSpace: 'nowrap',
    },
  },
};

const FormStyle: ComponentStyleConfig = {
  variants: {
    floating: floatingVariant,
  },
};

export default FormStyle;
